export interface Service {
  slug: string;
  title: string;
  short: string;
  description: string;
  details: string[];
  tags: string[];
  /** Shown in the compact home index */
  featured?: boolean;
}

export const services: Service[] = [
  {
    slug: "websites",
    title: "בניית אתרים",
    short: "אתרים מותאמים אישית בטכנולוגיות מתקדמות",
    description:
      "לא עוד אתר מתבנית. אנחנו מפתחים אתרים מאפס בטכנולוגיות React ו-Next.js: אתרים מהירים, מאובטחים ומותאמים מובייל שמדורגים גבוה בגוגל ומייצרים המרות.",
    details: [
      "אתרי תדמית, דפי נחיתה, אתרי מסחר וחנויות אונליין",
      "פיתוח מותאם אישית, ללא Wix, Wordpress או תבניות מוכנות",
      "אופטימיזציה לביצועים: ציון 90+ ב-Google PageSpeed",
      "עיצוב רספונסיבי מושלם: מובייל, טאבלט ודסקטופ",
      "אינטגרציות: מערכות סליקה, CRM, אוטומציות, אנליטיקה",
      "ליווי מלא מאפיון ועד העלייה לאוויר",
    ],
    tags: ["React", "Next.js", "TypeScript", "Tailwind CSS"],
    featured: true,
  },
  {
    slug: "mobile-apps",
    title: "אפליקציות מובייל",
    short: "אפליקציות iOS ואנדרואיד, מהאפיון ועד החנות",
    description:
      "אפליקציה שיוצאת לחנויות ונשארת שם. אנחנו לוקחים את הפרויקט מהאפיון ועד ההגשה ל-App Store ול-Google Play, כולל התחזוקה והעדכונים אחרי ההשקה.",
    details: [
      "פיתוח לשתי הפלטפורמות מקוד אחד: iOS ואנדרואיד",
      "הגשה מלאה ל-App Store ול-Google Play כולל טיפול בדחיות",
      "עבודה אופליין, סנכרון ברקע והתראות Push",
      "גישה למצלמה, מיקרופון, מיקום, זיהוי דיבור וחיישני מכשיר",
      "מסכי אונבורדינג, מנגנוני שימור ומדידת שימוש בפועל",
      "עדכוני גרסה, מעקב קריסות ותמיכה שוטפת",
    ],
    tags: ["iOS", "Android", "Capacitor", "React Native"],
    featured: true,
  },
  {
    slug: "web-apps",
    title: "אפליקציות ווב ומערכות SaaS",
    short: "מערכות ניהול, פלטפורמות SaaS ופתרונות Full Stack",
    description:
      "מערכות ניהול, פלטפורמות SaaS, ואפליקציות Full Stack: כל מה שצריך קוד מותאם ולא פתרון מדף.",
    details: [
      "פיתוח מערכות SaaS עם ארכיטקטורה סקיילבילית",
      "אפליקציות ניהול מלאי, הזמנות, לקוחות ותהליכים",
      "ממשקי API ואינטגרציות עם מערכות צד שלישי",
      "מערכות אימות, הרשאות וניהול משתמשים",
      "בסיסי נתונים, מיגרציות וגיבויים",
      "תחזוקה, עדכונים ותמיכה טכנית שוטפת",
    ],
    tags: ["Full Stack", "Node.js", "PostgreSQL", "REST API"],
    featured: true,
  },
  {
    slug: "dashboards",
    title: "דשבורדים, Big Data ודוחות אנליטיקה",
    short: "דאטה גולמי נכנס בצד אחד, החלטה ברורה יוצאת בצד השני",
    description:
      "רוב הארגונים לא סובלים ממחסור בנתונים אלא מעודף. אנחנו בונים את השכבה שהופכת מאגרי מידע גדולים לתמונת מצב אחת שאפשר לקרוא בשנייה ולפעול לפיה.",
    details: [
      "דשבורדים אינטראקטיביים בזמן אמת עם הרשאות לפי תפקיד",
      "חיבור למקורות מרובים: מסדי נתונים, APIs, Google Sheets, קבצי CSV",
      "ויזואליזציה מדויקת: סדרות זמן, מפות חום, פילוחים והשוואות",
      "דוחות אוטומטיים מתוזמנים בעברית ובאנגלית, מוכנים לשליחה ללקוח",
      "זיהוי מגמות, חריגות והזדמנויות בדאטה",
      "עיבוד וניתוח מאגרי נתונים גדולים (Big Data)",
    ],
    tags: ["BI", "Data Viz", "Big Data", "Dashboards"],
    featured: true,
  },
  {
    slug: "ai-agents",
    title: "סוכנים חכמים ואוטומציה",
    short: "AI שעובד 24/7 בשבילכם, לא צ'אטבוט שמתנצל",
    description:
      "בניית סוכנים מבוססי AI שעובדים בשבילכם מסביב לשעון: מענה אוטומטי ללקוחות, עיבוד מידע, ייעול תהליכים וחיסכון בזמן ובמשאבים.",
    details: [
      "סוכני AI שמבצעים משימות מורכבות באופן אוטונומי",
      "צ'אטבוטים חכמים לשירות לקוחות ומכירות",
      "מערכות RAG: שאילתות על מסמכים ומאגרי מידע פנימיים",
      "דוחות מבוססי ראיות שכל טענה בהם נסמכת על המקור",
      "אינטגרציה עם GPT, Claude ומודלים מתקדמים",
      "אוטומציה של email, WhatsApp, CRM ותהליכים חוזרים",
    ],
    tags: ["AI Agents", "LLM", "RAG", "Automation"],
    featured: true,
  },
  {
    slug: "seo",
    title: "קידום אתרים SEO",
    short: "עמוד ראשון בגוגל עם תנועה אורגנית מוכחת",
    description:
      "אסטרטגיית SEO מקיפה ומותאמת אישית שמביאה אתכם לעמוד הראשון בגוגל. לא טריקים זמניים, אלא בנייה אורגנית ארוכת טווח שצוברת תאוצה עם הזמן.",
    details: [
      "מחקר מילות מפתח מעמיק וזיהוי הביקושים האמיתיים של הקהל",
      "אופטימיזציית On-Page: כותרות, מטא, מבנה URL, Schema",
      "בניית תוכן ממוקד וממיר",
      "בניית קישורים איכותית ובטוחה",
      "SEO טכני: מהירות, Core Web Vitals, ניידות, אינדוקס",
      "דוחות מעקב חודשיים עם מדדים ברורים",
    ],
    tags: ["SEO", "Technical SEO", "Content", "Schema"],
    featured: true,
  },
  {
    slug: "ppc",
    title: "קמפיינים ממומנים",
    short: "Google Ads ו-Meta Ads עם ROI מקסימלי",
    description:
      "ניהול קמפיינים מבוססי דאטה בגוגל, פייסבוק, אינסטגרם וטיקטוק, עם מיקוד בהורדת עלות לליד, הגדלת המרות ומקסום ROI.",
    details: [
      "Google Ads: חיפוש, שופינג, דיספליי, YouTube",
      "Meta Ads: פייסבוק ואינסטגרם עם קהלים מותאמים",
      "TikTok Ads לחשיפה ויראלית ויצירת לידים",
      "בניית משפכי שיווק ומסעות לקוח",
      "A/B Testing מתמיד של מודעות, קהלים ודפי נחיתה",
      "דוחות ביצועים שקופים עם תובנות פעולתיות",
    ],
    tags: ["Google Ads", "Meta Ads", "TikTok", "PPC"],
  },
  {
    slug: "ux-ui",
    title: "עיצוב UX/UI",
    short: "ממשקים שלא רק נראים טוב, גם עובדים",
    description:
      "עיצוב ממשקים שמשפר המרות ומעלה שביעות רצון: מחקר משתמשים, ארכיטקטורת מידע, פרוטוטייפ ועיצוב סופי.",
    details: [
      "מחקר משתמשים: ראיונות, סקרים, ניתוח התנהגות",
      "ארכיטקטורת מידע ותרשימי זרימה",
      "Wireframes ופרוטוטייפ אינטראקטיבי ב-Figma",
      "עיצוב ויזואלי בהתאמה למיתוג הקיים",
      "עיצוב רספונסיבי Mobile First",
      "בדיקות שמישות ואופטימיזציית המרות",
    ],
    tags: ["Figma", "UX Research", "Prototyping", "UI Design"],
  },
  {
    slug: "analytics",
    title: "אנליטיקה ומעקב ביצועים",
    short: "כל שקל שאתם משקיעים נמדד ומנותח",
    description:
      "הגדרת מערכת מדידה מקצה לקצה, מהתקנת פיקסלים ועד דוחות מנהלים.",
    details: [
      "הגדרת Google Analytics 4, Tag Manager, Conversion Tracking",
      "הגדרת אירועים ומשפכי המרה מותאמים",
      "חיבור Google Ads, Meta Pixel, TikTok Pixel",
      "דוחות שבועיים וחודשיים מותאמים עם KPIs ברורים",
      "A/B Testing מבוסס דאטה לדפי נחיתה ומודעות",
      "זיהוי צווארי בקבוק במשפך ואופטימיזציה שוטפת",
    ],
    tags: ["GA4", "GTM", "דוחות", "A/B Testing"],
  },
  {
    slug: "strategy",
    title: "אסטרטגיה דיגיטלית",
    short: "לפני שמתחילים לבנות, חושבים",
    description:
      "ניתוח מעמיק של העסק, השוק והמתחרים, ובניית תוכנית דיגיטלית מלאה שמותאמת ליעדים ולתקציב.",
    details: [
      "ניתוח מתחרים: מה הם עושים, איפה הם חלשים, איפה ההזדמנות",
      "מיפוי קהלי יעד ופרסונות לקוח",
      "בניית אסטרטגיית תוכן רב-ערוצית",
      "תכנון תקציב שיווקי ו-ROI צפוי",
      "בניית Roadmap דיגיטלי שנתי עם אבני דרך מדידות",
      "ליווי שוטף, התאמות ואופטימיזציה לפי תוצאות",
    ],
    tags: ["אסטרטגיה", "ניתוח שוק", "Roadmap", "תכנון"],
  },
  {
    slug: "innovation",
    title: "חדשנות יצירתית",
    short: "פתרונות שסוכנות אחרת לא תציע כי היא לא יודעת שהם קיימים",
    description:
      "גישה שמשלבת טכנולוגיה מתקדמת עם חשיבה אמנותית, ומייצרת פתרונות שלא נמצאים בקטלוג של אף אחד.",
    details: [
      "פיתוח מוצרים דיגיטליים חדשניים מאפס",
      "שילוב AI בתהליכים קיימים",
      "אפליקציות מבוססות Computer Vision וזיהוי תמונה",
      "פרויקטי R&D וניסויים טכנולוגיים",
      "חשיבה מחוץ לקופסה",
      "רקע מוזיקלי ואמנותי שמביא זווית ייחודית",
    ],
    tags: ["R&D", "AI", "Computer Vision", "Innovation"],
  },
];

export const featuredServices = services.filter((s) => s.featured);
